<template>
  <div class="page playback-insight-container">
    <LayoutContainer>
      <!-- <div class="page-header">
        <h1 class="title"><i class="fas fa-lightbulb icon"></i> Playback Insight</h1>
      </div> -->
      <div class="page-content playback-insight">
        <PreLoaderSection
          :options="{ 'height': '500', enabledTwoColumns: true }"
          v-if="state.isPreLoaderShowing" />
        <router-view />
      </div>
    </LayoutContainer>
  </div>
</template>

<script>
import LayoutContainer from '@/layout/LayoutContainer.vue';
import PreLoaderSection from '@/components/PreLoaderSection.vue';

export default {
  components: {
    LayoutContainer,
    PreLoaderSection,
  },
  data() {
    return {
      preloaderCustomClass: 'two-columns',
      disabledDate: ['forever', 'today', 'last7days', 'last30days', 'custom'],
      dateFilter: null,
      error: null,
      state: {
        isPreLoaderShowing: true,
      },
    };
  },
  created() {
    this.state.isPreLoaderShowing = false;
    // TODO: Load necessary APIs here
  },
  computed: {
    teamName() {
      return this.$route.params.teamName;
    },
    projectId() {
      return this.$route.params.projectId;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';
</style>
